import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AvatarComponent } from '../../../avatar/avatar.component';
import { AppIconComponent } from '../../../icon/icon.component';
import { SoundIconComponent } from '../../../sound-icon/sound-icon.component';
import { TammiDeviceBadgeComponent } from '../../../tammi-device-badge/tammi-device-badge.component';

export interface VideoItemData {
  isSpeaking: boolean;
  isShareScreen: boolean;
  micOn: boolean;
  camOn: boolean;
  videoId: string;
  id: string;
  avatar: string;
  name: string;
  volume: number;
  label: string;
  device: boolean;
  avatarSize?: number;
}

@Component({
  selector: 'app-call-video-item',
  standalone: true,
  imports: [AppIconComponent, AvatarComponent, SoundIconComponent, TammiDeviceBadgeComponent],
  templateUrl: './call-video-item.component.html',
  styleUrl: './call-video-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallVideoItemComponent {
  data = input.required<VideoItemData>();
}
